<template>
  <div v-if="MENSAGEM.length > 0" class="h-30px text-white px-2 d-flex align-center bg-systock-1 w-screen">
    <v-menu offset-y open-on-hover open-delay="1000" :max-width="600">
      <template #activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on" class="cursor-help text-truncate py-1 font-14">
          <span class="ma-0 pr-15" v-text="`Observações: ${MENSAGEM}`" />
        </div>
      </template>

      <div class="bg-white pa-5 font-14 text-justify">
        <div v-if="pedido.observacao_fornecedor">
          <p class="ma-0 font-weight-medium font-14">Observação do fornecedor</p>
          <p v-text="pedido.observacao_fornecedor" class="ma-0 font-14" />
        </div>

        <div v-else-if="pedido.observacao_grupo_analise">
          <p class="ma-0 font-weight-medium font-14">Observação do grupo de análise</p>
          <p v-text="pedido.observacao_grupo_analise" class="ma-0 font-14" />
        </div>

        <div v-if="pedido.observacao_pedido" class="mt-3">
          <p class="ma-0 font-weight-medium font-14">Observação do pedido de compra</p>
          <p v-text="pedido.observacao_pedido" class="ma-0 font-14" />
        </div>
      </div>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "ObservacoesRodape",
  props: ['pedido'],
  computed: {
    MENSAGEM () {
      if (!this.pedido) return '';

      const {observacao_fornecedor, observacao_pedido, observacao_grupo_analise} = this.pedido;
      let txt = '';

      if (observacao_grupo_analise) {
        txt = txt.length > 0 ? `${txt} ${observacao_grupo_analise}` : observacao_grupo_analise;
      } else if (observacao_fornecedor) {
        txt = txt.length > 0 ? `${txt} ${observacao_fornecedor}` : observacao_fornecedor;
      }

      if (observacao_pedido) {
        txt = txt.length > 0 ? `${txt} - ${observacao_pedido}` : observacao_pedido;
      }

      return txt;
    }
  }
}
</script>

<style scoped>
</style>
